import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { APP_FILE_TAX_REPORT } from "../Acoounting.constants";
import { MODULE_IDS } from "../../../constants/enums";

const TaxReport = Loadable(
  lazy(() =>
    import("./TaxReport").then(({ TaxReport }) => ({
      default: TaxReport,
    }))
  )
);


export const TaxReportsRouter = [
  {
    path: `${APP_FILE_TAX_REPORT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.REPORTS_TAX_REMITTANCE]}>
        <TaxReport />
      </AuthorizedRoute>
    ),
  },
  
];
